@import '../../assets/styles/components.css';

@layer components {
  :host {
    /**
     * In order for Tooltip to remain open when hovering over itself,
     * pointer-events-auto must be applied to the label host.
     */
    @apply font-semibold gap-0.5 inline-flex items-center leading-4 pointer-events-auto text-xs;

    &([required]) {
      @apply before:content-['*'] before:self-start before:text-danger;
    }

    &([weight='medium']) {
      @apply font-medium leading-5 text-sm;
    }

    abds-icon {
      @apply ml-0.5 text-brand;
      @apply focus:outline-none focus:ring focus:ring-primary-200;
    }
  }
}
